import { Layout } from "antd";
import Header from "./Components/Header";
import { Outlet } from "react-router";
import TabBar from "./Components/TabBar";
import { analyticsLogEvent } from "../data/firebase/analytics";
import "../data/sentry";
import Feedback from "./Components/Feedback";
import WishlistFooter from "./Footer";
import { useCurrentRoute } from "@/data/hooks";
import { RoutePaths } from "./routes";

const { Content } = Layout;

const siderStyle: React.CSSProperties = {
  minHeight: "100vh",
};

export default function App() {
  const route = useCurrentRoute();
  analyticsLogEvent("app_rendered");

  return (
    <>
      <Layout style={siderStyle}>
        <Header />
        <Layout style={{ background: "white" }}>
          <Content>
            <Outlet />
          </Content>
        </Layout>
        <TabBar />
        <Feedback />
        {route == RoutePaths.root || <WishlistFooter />}
      </Layout>
    </>
  );
}
